module.exports = __webpack_public_path__ + "img/rec-filter-icon.e1f17d03.png";